import { Badge, Group, createStyles } from '@mantine/core';

import { FRAMEWORK_LOGO_ENDPOINT } from '@/config/endpoint';
import Image from 'next/image';
import { isDark } from '@/utils/utils';
import themeVariables from '@/styles/themeVariables';

const createTechstackAvatarBadgeGroupStyles = createStyles(() => ({
  wrapper: {
    gap: 6,
    maxHeight: 60,
  },

  badge: {
    borderRadius: '50px',
    height: 28,
    lineHeight: 1.55,
    fontSize: 11,
    fontWeight: 600,
    boxShadow: themeVariables.boxShadow.lightShadow,
    width: 'fit-content',
    cursor: 'pointer',
    textTransform: 'none',
    paddingLeft: 1,
  },
}));

const TechstackAvatarBadgeGroup = ({
  techstacks = [],
  onClick = () => null,
  index = 4,
}) => {
  const { dark } = isDark();
  const { classes } = createTechstackAvatarBadgeGroupStyles();

  return (
    <Group className={classes.wrapper}>
      {techstacks.slice(0, index).map((techstack) => (
        <Badge
          key={techstack.id}
          id={techstack.id}
          autoCapitalize={'false'}
          className={classes.badge}
          sx={{
            backgroundColor: themeVariables.darkMode.bgDark(dark),
            color: themeVariables.darkMode.neutral(dark),
            border: `1px solid ${themeVariables.lineDark.light300(dark)}`,
          }}
          onClick={onClick}
          leftSection={
            <Image
              width={28}
              height={28}
              style={{
                borderRadius: 14,
                padding: 3,
              }}
              src={`${FRAMEWORK_LOGO_ENDPOINT}/${techstack.id}.png`}
              alt="language-logo"
            />
          }
        >
          {techstack.name}
        </Badge>
      ))}
    </Group>
  );
};

export default TechstackAvatarBadgeGroup;
